import t from"./is-object.js";var o=t,i=String,e=TypeError,a=function(r){if(o(r))return r;throw e(i(r)+" is not an object")};export{a as default};
